export const BASE_URL =
	process.env.REACT_APP_ENV === "production"
		? "https://api.applaby.com"
		: "http://127.0.0.1:8010"; //"https://dev.applaby.com:8010";
export const API_URL = BASE_URL + "/api/";
export const ADMIN_URL = BASE_URL + "/admin/";
